import { render, staticRenderFns } from "./SavPaieskaTab.vue?vue&type=template&id=cc4eaf40&scoped=true&"
import script from "./SavPaieskaTab.vue?vue&type=script&lang=js&"
export * from "./SavPaieskaTab.vue?vue&type=script&lang=js&"
import style0 from "./SavPaieskaTab.vue?vue&type=style&index=0&id=cc4eaf40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4eaf40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VContainer,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSheet})
